import moment, { normalizeUnits, suppressDeprecationWarnings } from "moment";
import CustomCalendar from "../CustomComponentsUI/CustomCalendar";
import CellEvent from "../CustomComponentsUI/CellEvent";
import CustomDialog from "../CustomComponentsUI/CustomDialog";
import SelectDialog from "../CustomComponentsUI/SelectDialog";
import FrmNewEvent from "../FrmNewEvent/FrmNewEvent";
import FrmNewAbsence from "../FrmNewEvent/FrmNewAbsence.vue";
import EventInfoModal from "./EventInfoModal";
import EasyPlanClient from "../../utils/EasyPlanClient";
import UISettingsHelper from "../../utils/UISettingsHelper";

import EventType from "../../settings/EventType";
import StepEmailUsernameVue from "../FrmRecoverPassword/Steps/StepEmailUsername.vue";
const SelectionMode = {
    COLUMNS: 0,
    ROWS: 1,
};
export default {
    props: {
        height: { type: Number, default: 400 },
        refreshInterval: { type: Number, default: 120000 },
        resourceType: { type: String, default: "All" },
        allowDragAndDropEvents: { type: Boolean, default: true },
        allowSelectCells: { type: Boolean, default: true },
        allowEditEvents: { type: Boolean, default: true },
        showCellHover: { type: Boolean, default: true },
        fullScreen: { type: Boolean, default: false },
        showToolbar: { type: Boolean, default: true },
        showTitlebar: { type: Boolean, default: true },
        showOptions: { type: Boolean, default: false },
        title: { type: String, default: "Pianificazione" },
        showBackButton: { type: Boolean, default: true },
    },
    watch: {
        showOptions(val) {
            this.showOptionsD = val;
        },
        resourceType(value, old) {
            this.loadResources(value);
            this.loadActions(value);
        },
        fullScreen(value) {
            this.fullscreen = value;

        },
    },
    components: {
        CellEvent,
        CustomCalendar,
        CustomDialog,
        FrmNewEvent,
        FrmNewAbsence,
        EventInfoModal,
        SelectDialog,
    },
    data() {
        return {
            users: [],
            isLoading: false,
            EventType: EventType,
            showOptionsD: false,
            showEventDetailsModal: false,
            selectedCellData: null,
            EditEventDialog: false,
            AbsenceEventDialog: false,
            moment: moment,
            selectedRow: 0,
            selectedColumn: 0,
            resizing: false,
            error: "",
            SelectionMode: SelectionMode,
            selectionMode: SelectionMode.ROWS,
            event: {},
            actions: [],
            defaultActions: [],
            testEvent: {},
            isEventCreatorP: false,
            fullscreen: false,
            selectedItems: [], //operatori,mezzi,attrezzature (per selectionMode=Rows)
            selectedDays: [], //giorni selezionati (per selectionMode=Columns)
            selectedItem: null, //operatore,mezzo, attrezzatura selezionata (per selectionMode=Columns)
            selectedDay: new Date(), // (per selectionMode=Rows)
            events: [],
            resources: [{ idRisorsa: "1", descrizione: "Loading" }],
        };
    },
    methods: {
        btnChangeEventOwner_Click() {
            this.$refs.selectNewEventOwner.ShowEdit(
                "Riassegna evento",
                "Seleziona dalla lista il nuovo proprietario di questo evento",
                ["Riassegna", "Annulla"],
                this.users.map((u) => {
                    return { value: u.idUtente, description: u.username };
                }),
                this.event.idCreatore,
                (res, selected) => {
                    if (res == "Riassegna") {
                        let user = this.users.find((u) => u.idUtente == selected);
                        console.debug("selectednewowner", selected);
                        console.debug("newowner", user);
                        console.debug("event", this.event);
                        this.event.color = user.colore;
                        this.event.idCreatore = user.idUtente;
                        this.event.risorseIntervento = [];
                        // for (var i = 0; i < this.event.risorse.length; i++)
                        //   this.event.risorseIntervento.push({
                        //     idRisorsa: this.event.risorse[i].idRisorsa,
                        //   });
                        this.updateEventOwner(this.event.idIntervento, user.idUtente, () => {
                            this.showEventDetailsModal = false;
                        });
                    }
                }
            );
        },
        loadActions(resourceType) {
            switch (resourceType) {
                case "All":
                    this.defaultActions = [
                        {
                            text: "Duplica",
                            vuetifyIcon: "mdi-content-duplicate",
                            vuetifyColor: "success",

                            visible: true,
                            action: () => {
                                this.error =
                                    "Tieni premuto CTRL e trascina l'evento sul giorno desiderato per duplicarlo";
                            },
                        },
                        {
                            text: "Sposta",
                            vuetifyIcon: "mdi-cursor-move",
                            vuetifyColor: "error",
                            visible: true,

                            action: () => {
                                this.error =
                                    "Trascina l'evento sul giorno desiderato per spostarlo";
                            },
                        },
                        {
                            text: "Assegna",
                            vuetifyIcon: "mdi-plus",
                            vuetifyColor: "primary",
                            visible: true,
                            action: this.btnAddClick,
                        },
                        {
                            text: "Assenza",
                            vuetifyIcon: "mdi-minus",
                            vuetifyColor: "grey darken-4 white--text",
                            visible: true,

                            action: this.btnAbsenceClick,
                        },
                        {
                            text: "Conferma",
                            vuetifyIcon: "mdi-checkbox-marked-circle",
                            vuetifyColor: "success",
                            visible: true,

                            action: this.btnConfirmClick,
                        },
                        {
                            text: "Annulla",
                            vuetifyIcon: "mdi-cancel",
                            vuetifyColor: "error",
                            visible: true,

                            action: this.btnCancelClick,
                        },
                    ];
                    break;
                default:
                    this.defaultActions = [
                        {
                            text: "Assegna",
                            visible: true,
                            vuetifyIcon: "mdi-plus",
                            vuetifyColor: "primary",

                            action: this.btnAddClick,
                        },
                        {
                            text: "Assenza",
                            vuetifyIcon: "mdi-minus",
                            vuetifyColor: "grey darken-4 white--text",
                            visible: true,

                            action: this.btnAbsenceClick,
                        },
                        {
                            text: "Conferma",
                            vuetifyIcon: "mdi-checkbox-marked-circle",
                            vuetifyColor: "success",
                            visible: true,

                            action: this.btnConfirmClick,
                        },
                        {
                            text: "Annulla",
                            vuetifyIcon: "mdi-cancel",
                            vuetifyColor: "error",
                            visible: true,

                            action: this.btnCancelClick,
                        },
                    ];
                    break;
            }
            this.actions = this.defaultActions;
        },
        showButtons(arrText) {
            if (arrText.length > 0) {
                for (let i = 0; i < this.defaultActions.length; i++) {
                    this.defaultActions[i].visible =
                        arrText.indexOf(this.defaultActions[i].text) >= 0;
                }
            } else {
                for (let i = 0; i < this.defaultActions.length; i++) {
                    this.defaultActions[i].visible = true;
                }
            }
            this.actions = [];
            this.actions = this.defaultActions;
        },
        hideButtons(arrText) {
            if (arrText.length > 0) {
                for (let i = 0; i < this.defaultActions.length; i++) {
                    this.defaultActions[i].visible =
                        arrText.indexOf(this.defaultActions[i].text) < 0;
                }
            } else {
                for (let i = 0; i < this.defaultActions.length; i++) {
                    this.defaultActions[i].visible = false;
                }
            }
            this.actions = [];
            this.actions = this.defaultActions;
        },
        btnAbsenceClick() {
            this.selectedItems = [];
            this.selectedDays = [];
            this.selectedDay = new Date();
            this.selectedItem = null;
            this.selectionMode = SelectionMode.COLUMNS;
            this.showButtons(["Annulla", "Conferma"]);
            this.error = 'Seleziona i giorni poi clicca su "Conferma"';
        },
        btnConfirmClick() {
            // this.AbsenceEventDialog = true;
            let title = "Motivo assenza"; //Valutare se riadattarlo per non disponibiltà altrea risorsa(es: collaudo risorsa ecc..)
            let reasons = [];
            let reasonsOperators = this.UISettings.planner.operatorsAbsenceReasons; //["Ferie", "Corsi", "Malattia", "Visite"] ;
            let reasonsVehicles = this.UISettings.planner.vehiclesAbsenceReasons;//["Manutenzione", "Noleggio", "Fermo"];
            let reasonsTools = this.UISettings.planner.equipmentsAbsenceReasons;///["Collaudo", "Guasto"];
            let buttons = ["Ok", "Annulla"];
            let description = "Seleziona il motivo dell'assenza";
            switch (this.resourceType) {
                case "All":
                    title = "Motivo assenza";
                    reasons = reasonsOperators;
                    description = "Seleziona il motivo dell'assenza";
                    break;
                case "Uomo":
                    title = "Motivo assenza";
                    reasons = reasonsOperators;
                    description = "Seleziona il motivo dell'assenza";
                    break;
                case "Mezzo":
                    title = "Motivo indisponibilità";
                    reasons = reasonsVehicles;
                    description = "Seleziona una delle opzioni";
                    break;
                case "Attrezzatura":
                    title = "Motivo indisponibilità";
                    reasons = reasonsTools.sort();
                    description = "Seleziona una delle opzioni";
                    break;
            }
            console.debug("this", this);
            console.debug("refs", this.$refs);
            this.$refs.selectDialog.Show(
                title,
                description,
                buttons,
                reasons.sort(),
                this.absenceConfirmed
            );
        },
        async absenceConfirmed(dr, reason) {
            if (dr == "Ok") {
                var abs = this.getAbsences(reason);
                for (let i = 0; i < abs.length; i++) await this.submitEvent(abs[i], () => { });
                console.debug(abs);
                // pushAbsences(reason, btnCancelClick);
            }
            this.btnCancelClick();
        },
        // pushAbsences(reason, callback) {},
        getAbsences(reason) {
            let abscences = [];
            for (let index = 0; index < this.selectedItems.length; index++) {
                let event = {
                    inizio: this.selectedItems[index].day,
                    fine: this.selectedItems[index].day,
                    giornoIntero: true,
                    risorse: [],
                    idCliente: null,
                    cliente: null,
                    idCommessa: null,
                    idSede: null,
                    risorseIntervento: [],
                    descrizioneIntervento: reason,
                    tipo: EventType.Assenza,
                    commessa: {
                        descrizione: "",
                    },
                    descrizione: reason,
                    note: reason,
                    lampeggia: false,
                    color: "#000",
                };
                event.risorse.push(this.selectedItems[index].item);
                abscences.push(event);
            }
            return abscences;
        },
        btnCancelClick() {
            this.selectedItems = [];
            this.selectedDays = [];
            this.selectedDay = new Date();
            this.selectedItem = null;

            this.hideButtons(["Annulla", "Conferma"]);
            this.selectionMode = SelectionMode.ROWS;
        },
        startDrag: (evt, day, item) => {
            // if (this.allowDragAndDropEvents==true) {
            evt.dataTransfer.dropEffect = "move";
            evt.dataTransfer.effectAllowed = "move";
            // }

            evt.dataTransfer.setData(
                "dragData",
                JSON.stringify({ item: item, day: day })
            );
        },
        EventMoved(event, inizio, fine) {
            if (event.tipo == EventType.Intervento)
                this.editEvent(event, inizio, fine);
        },
        EventCloned(event, inizio, fine) {
            let ev = { ...event };
            ev.idIntervento = 0;
            if (event.tipo == EventType.Intervento)
                this.cloneEvent(event, event, inizio, fine);
            //  this.editEvent(event, inizio, fine);
        },
        GetItemId(date, item) {
            return moment(date).format("YYYYMMDD") + item.idRisorsa;
        },
        getEvent(day, operator) {
            if (this.events != undefined)
                return this.events.find(
                    (e) =>
                        e.risorseIntervento.find(
                            (e) => e.idRisorsa == operator.idRisorsa
                        ) != undefined &&
                        moment(e.inizio).format("YYYYMMDD") ==
                        moment(day.date).format("YYYYMMDD")
                );
            else return [];
        },
        getEventById(eventId) {
            if (this.events != undefined)
                return this.events.find(
                    (e) => e.idIntervento == eventId
                );
            else return [];
        },
        getEvents(day, operator) {
            return this.events
                .filter(
                    (e) =>
                        e.risorseIntervento.find(
                            (e) => e.idRisorsa == operator.idRisorsa
                        ) != undefined &&
                        moment(e.inizio).format("YYYYMMDD") ==
                        moment(day.date).format("YYYYMMDD")
                )
                .sort((a, b) => a.inizio > b.inizio);
        },
        EventClick(day, item, event, isCreator) {
            if (this.allowEditEvents) {
                console.debug("loading event", event);
                console.debug("item 2", item);
                this.selectedCellData = item;
                console.debug("EventClick", this.selectedCellData);
                let ev = event; // this.getEvent(day, item);
                this.isEventCreatorP = isCreator;
                switch (this.resourceType) {
                    case "All": {
                        this.isLoading = true;

                        this.event = event;
                        console.debug("event", this.event);
                        this.showEventDetailsModal = true;

                        this.isLoading = false;
                        // this.loadEvent(ev.idIntervento, (event) => {
                        //   this.isLoading = false;
                        //   this.event = event;
                        //   this.showEventDetailsModal = true;
                        //   this.$refs.eventModal.setDefaultTab();
                        // });
                    }

                        break;
                    case "Uomo":
                        this.Edit_Resources(item, ev, "operatori", ev.inizio);
                        break;
                    case "Mezzo":
                        this.Edit_Resources(item, ev, "veicoli", ev.inizio);
                        break;
                    case "Attrezzatura":
                        this.Edit_Resources(item, ev, "attrezzature", ev.inizio);
                        break;
                }
            }

        },
        isChecked(item) {
            return this.selectedItems.find((i) => i.id == item.id) != undefined;
        },
        AbsenceClick(day, item, event, isCreator) {
            console.debug("event", event);
            console.debug("item 2", item);
            this.selectedCellData = item;
            console.debug("EventClick", this.selectedCellData);
            let ev = event; // this.getEvent(day, item);
            this.isEventCreatorP = isCreator;
            this.loadEvent(ev.idIntervento, (event) => {
                this.event = event;
                this.showEventDetailsModal = true;
                this.$refs.eventModal.setDefaultTab();
            });
        },
        CellClick_SelectionRows(day, item) {
            //Per gli eventi
            if (this.selectedDay.date != day.date) {
                if (this.selectedItems.length > 0) {
                    this.selectedItems = []; //se ha cambiato il  giorno deseleziono gli altri
                }
                this.selectedDay = day;
            }

            if (this.selectedItems.find((i) => i.id == item.id) != undefined) {
                //deseleziono se è già selezionato
                this.selectedItems = this.selectedItems.filter((i) => i.id != item.id);
            } else {
                //seleziono nuona risorsa
                this.selectedItems.push(item);
            }
        },
        CellClick_SelectionColumns(day, item) {
            //Per le assenze
            console.debug("item", item);
            console.debug("selectedItem", this.selectedItem);
            let evs = this.getEvents(day, item.item);
            if (evs.length == 0) {
                if (this.selectedItem != null)
                    if (
                        this.selectedItems.length > 0 &&
                        this.selectedItem.item.idRisorsa != item.item.idRisorsa
                    ) {
                        this.selectedItems = []; //se ha cambiato risorsa deseleziono le altre
                    }
                if (this.selectedItems.find((i) => i.id == item.id) != undefined) {
                    //deseleziono se è già selezionato
                    this.selectedItems = this.selectedItems.filter(
                        (i) => i.id != item.id
                    );
                } else {
                    //seleziono nuona risorsa
                    this.selectedDay = day;
                    this.selectedItem = item;
                    this.selectedItems.push(item);
                }
            } else {
                this.error =
                    "La risorsa è già assegnata ad un'evento per il giorno selezionato, rimuverla dall'evento prima di procedere.";
            }

            // if (this.selectedDay != null)
            //   if (
            //     this.selectedDays.length > 0 &&
            //     this.day.date.toUTCString() != this.selectedDay.date.toUTCString()
            //   ) {
            //     this.selectedItems = []; //se ha cambiato il  giorno deseleziono gli altri
            //     this.selectedDays = []; //se ha cambiato il  giorno deseleziono gli altri
            //   }
            // if (this.selectedItems.find((i) => i.id == item.id) != undefined) {
            //   //deseleziono se è già selezionato
            //   this.selectedItems = this.selectedItems.filter((i) => i.id != item.id);
            //   this.selectedDays = this.selectedDays.filter((i) => i.date != day.date);
            // } else {
            //   if (this.$props.selectionMode == SelectionMode.ROWS)
            //     this.selectedDay = day;
            //   this.selectedItems.push(item);
            //   this.selectedDays.push(day);
            // }
        },
        CellClick(day, item) {
            // console.debug("item", item);
            //  this.selectedCellData = null;
            if (this.allowSelectCells) {
                if (this.selectionMode == SelectionMode.ROWS) {
                    this.CellClick_SelectionRows(day, item);
                } else {
                    this.CellClick_SelectionColumns(day, item);
                }
            }


            // if (this.selectedItems.length > 0 && this.selectedDay.date != day.date) {
            //   this.selectedItems = []; //se ha cambiato il  giorno deseleziono gli altri
            // }
            // let itemId = this.GetItemId(day.date, item);
        },
        createItem(day, operator) {
            let itemId = this.GetItemId(day.date, operator);
            let item = { id: itemId, day: day.date, item: operator };
            return item;
        },
        loadEvent(eventId, callback) {
            console.log("loading event", eventId);
            EasyPlanClient.Event.Find(this.$route.params.companyAlias, eventId)
                .then((res) => {
                    this.event = res.data.data;

                    console.log(this.event);
                    this.event.risorse = [];
                    //le risorse vengono gestite come risorse dai vari stepper coinvolti, quindi per eventi già esistenti, per far selezionare correttamente le checkbox, bisogna ricaricare le cose
                    this.event.risorseIntervento.forEach((element) => {
                        this.event.risorse.push(element.risorsa);
                    });
                    callback(this.event);
                    // this.dialog = true;
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        editEvent(ev, inizio = null, fine = null) {
            console.debug("EDIT", ev);
            this.loadEvent(ev.idIntervento, (event) => {
                if (inizio != null) this.event.inizio = inizio;
                if (fine != null) this.event.fine = fine;
                this.EditEventDialog = true;
            });
        },

        cloneEvent(oldev, ev, inizio = null, fine = null) {
            this.loadEvent(oldev.idIntervento, (event) => {
                this.event.idIntervento = 0;
                this.event.risorseIntervento = oldev.risorseIntervento;
                console.log("nuovo evento clonato", this.event.risorseIntervento);
                if (inizio != null) this.event.inizio = inizio;
                if (fine != null) this.event.fine = fine;
                this.EditEventDialog = true;
            });
        },
        deleteEvent(ev) {
            EasyPlanClient.Event.Delete(
                this.$route.params.companyAlias,
                ev.idIntervento
            )
                .then((res) => {
                    this.events = this.events.filter(
                        (e) => e.idIntervento != ev.idIntervento
                    );
                    this.event = null;
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        btnEditEvent_Click() {
            this.editEvent(
                this.event //this.getEvent(this.selectedCellData.day, this.selectedCellData.item)
            );
            this.showEventDetailsModal = false;
        },
        btnRemoveEvent_Click() {
            this.deleteEvent(
                this.event //this.getEvent(this.selectedCellData.day, this.selectedCellData.item)
            );
            this.showEventDetailsModal = false;
        },
        btnAddClick() {
            switch (this.resourceType) {
                case "All":
                    this.Add_All();
                    break;
                case "Mezzo":
                    this.Add_Resources("veicoli");
                    break;
                case "Attrezzatura":
                    this.Add_Resources("attrezzature");
                    break;
                case "Uomo":
                    this.Add_Resources("operatori");
                    break;
            }
        },

        Edit_Resources(item, ev, resName, day) {

            if (this.isEventCreatorP || this.canEditOtherUserEvents()) {
                // if (this.selectedItems.length > 0) {
                console.debug("ev", ev);
                item = item.item;
                console.debug("item", item);

                let btnAddText = "Riassegna " + resName;
                let filtered = this.events.filter(
                    (e) =>
                        moment(e.inizio).format("DD/MM/YYYY") ==
                        moment(day).format("DD/MM/YYYY")
                );
                let current = filtered.find((e) => e.idIntervento == ev.idIntervento);
                let buttons = [btnAddText, "Rimuovi", "Annulla"];
                // Show(title, description, buttons, items, callback,selectedValue)
                this.$refs.selectDialog.ShowEdit(
                    "Seleziona un evento",
                    "la risorsa verrà assegnata all'evento selezionato. Gli eventi mostrati sono filtrati per il giorno '" +
                    moment(day).format("DD/MM/YYYY") +
                    "'",
                    buttons,
                    filtered.map((e) => {
                        return { value: e, description: e.cliente.descrizione.toUpperCase() + ' - ' + e.descrizione.toUpperCase() };
                    }, item.idRisorsa),
                    current,
                    (btn, newEv) => {
                        switch (btn) {
                            case btnAddText: //RIASSEGNA
                                {
                                    //rimuovo da ev precedente
                                    ev.risorseIntervento = ev.risorseIntervento.filter(
                                        (ri) =>
                                            ri.idIntervento == ev.idIntervento &&
                                            ri.idRisorsa != item.idRisorsa
                                    );

                                    this.updateEvent(ev, () => {
                                        //aggiungo a newEv
                                        let ri = {
                                            idIntervento: newEv.idIntervento,
                                            idRisorsa: item.idRisorsa,
                                        };
                                        newEv.risorseIntervento.push(ri);
                                        this.updateEvent(newEv);
                                    });
                                }

                                break;
                            case "Rimuovi":
                                {
                                    console.debug("Rimuovo...");
                                    ev.risorseIntervento = ev.risorseIntervento.filter(
                                        (ri) =>
                                            ri.idIntervento == ev.idIntervento &&
                                            ri.idRisorsa != item.idRisorsa
                                    );
                                    console.debug("rimosso.");
                                    this.updateEvent(ev);
                                }
                                break;
                        }
                    }
                );
            }


        },
        Add_Resources(resName) {
            if (this.selectedItems.length > 0) {
                let btnAddText = "Aggiungi " + resName;
                let filtered = this.events.filter(
                    (ev) =>
                        moment(ev.inizio).format("DD/MM/YYYY") ==
                        moment(this.selectedItems[0].day).format("DD/MM/YYYY") &&
                        ev.tipo == EventType.Intervento //filtro assenze

                );

                this.$refs.selectDialog.Show(
                    "Seleziona un evento",
                    "la risorsa verrà assegnata all'evento selezionato. Gli eventi mostrati sono filtrati per il giorno '" +
                    moment(this.selectedItems[0].day).format("DD/MM/YYYY") +
                    "'",
                    [btnAddText, "Annulla"],
                    filtered.map((e) => {
                        return { value: e, description: e.cliente.descrizione.toUpperCase() + ' - ' + e.descrizione.toUpperCase() };
                    }),
                    (btn, ev) => {
                        if (btn == btnAddText) {
                            for (let i = 0; i < this.selectedItems.length; i++) {
                                let ri = {
                                    idIntervento: ev.idIntervento,
                                    idRisorsa: this.selectedItems[i].item.idRisorsa,
                                };
                                console.debug("ri" + i, ri);

                                ev.risorseIntervento.push(ri);
                            }
                            this.updateEvent(ev);
                        }
                    }
                );

                // this.EditVehiclesDialog = true;
                // for (let index = 0; index < this.selectedItems.length; index++) {
                //   this.event.risorse.push(this.selectedItems[index].item);
                // }
                // console.debug(this.event);
            } else {
                this.error = "Select resources";
            }
        },
        Add_All() {
            if (this.selectedItems.length > 0) {
                this.event = {
                    inizio: this.selectedItems[0].day,
                    fine: this.selectedItems[0].day,
                    giornoIntero: true,
                    risorse: [],
                    idCliente: 0,
                    risorseIntervento: [],
                    descrizioneIntervento: "",
                    tipo: EventType.Intervento,
                    commessa: {
                        descrizione: "",
                    },
                    descrizione: "",
                    note: "",
                    lampeggia: false,
                };
                this.EditEventDialog = true;
                for (let index = 0; index < this.selectedItems.length; index++) {
                    this.event.risorse.push(this.selectedItems[index].item);
                }
            } else {
                this.error = "Select resources";
            }
        },
        async submitEvent(event) {
            event.risorseIntervento = [];
            // this.evento.inizio=moment(this.evento.inizio ).format("MM/DD/YYYY HH:mm");
            // this.evento.fine=moment(this.evento.fine ).format("MM/DD/YYYY HH:mm");
            for (var i = 0; i < event.risorse.length; i++)
                event.risorseIntervento.push({
                    idRisorsa: event.risorse[i].idRisorsa,
                });
            this.event_Adding({ ...event });
            await EasyPlanClient.Event.Insert(this.$route.params.companyAlias, event)
                .then((res) => {
                    console.debug("risposta add event:", res);
                    event.risorse = [];

                    this.event_Added(res.data.data);
                    // this.users.push(res.data.data);
                    // this.loadUsers();
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        updateEvent: function (ev, callback = function () { }) {
            ev.risorse = [];
            // this.evento.inizio=this.evento.inizio.toLocaleString();
            // this.evento.fine=this.evento.fine.toLocaleString();
            console.debug("Aggiorno...");
            EasyPlanClient.Event.Update(
                this.$route.params.companyAlias,
                ev.idIntervento,
                ev
            )
                .then((res) => {
                    console.debug("aggiornato.");
                    ev.risorse = [];
                    this.event_Updated(ev);
                    callback();
                    // this.$emit("eventUpdated", res.data.data);
                    // this.users.push(res.data.data);
                    // this.loadUsers();
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },

        updateEventOwner: function (evId, newOwnerId, callback = function () { }) {
            // ev.risorse = [];
            // this.evento.inizio=this.evento.inizio.toLocaleString();
            // this.evento.fine=this.evento.fine.toLocaleString();
            console.debug("Aggiorno owner...");
            EasyPlanClient.Event.UpdateOwner(
                this.$route.params.companyAlias,
                evId,
                newOwnerId
            )
                .then((res) => {
                    console.debug("aggiornato.");
                    // ev.risorse = [];
                    this.event_Updated(res.data.data);
                    callback();
                    // this.$emit("eventUpdated", res.data.data);
                    // this.users.push(res.data.data);
                    // this.loadUsers();
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        event_Updated(event) {
            this.EditEventDialog = false;
            this.event = {};
            this.events.push(event);
            this.events = this.events.filter(
                (e) => e.idIntervento != event.idIntervento
            );
            this.events.push(event);
            this.selectedItems = [];
            this.loadEvent(event.idIntervento, (event) => {
            });
        },
        event_Added(event) {
           
            this.loadEvent(event.idIntervento, (e) => { 
                console.debug("event added", e);
                this.isLoading = false;
                // this.EditEventDialog = false;
                this.event = {};
                // this.events.push(event);
                this.events = this.events.filter(
                    (e) => e.idIntervento != "TMP"
                );
                this.events.push(e);
                let tmp = this.events;
                this.events = [];
                this.events = tmp;

            });
            // this.selectedItems = [];
        },
        event_Adding(event) {
            console.debug("event adding...", event);
            this.EditEventDialog = false;
            this.isLoading = true;
            // let tmpEv=event.splice();
            event.idIntervento = "TMP";
            event.color = "#AAA";
            if (event.cliente == null)
                event.cliente = { descrizione: '' };
            this.events.push(event);
            let tmp = this.events;
            this.events = [];
            this.events = tmp;
            this.selectedItems = [];
        },
        btnRemoveClick() {
            alert("remove");
        },
        loadWorkers() {
            console.log("loading workers...");
            EasyPlanClient.Resources.GetAllOperators(this.$route.params.companyAlias)
                .then((res) => {
                    this.resources = res.data.data.sort((a, b) => {
                        if (a.prioritaOrdinamento > b.prioritaOrdinamento) {
                            return 1;
                        }
                        else if (a.prioritaOrdinamento < b.prioritaOrdinamento) {
                            return -1;
                        }
                        else {

                            return ((a.descrizione > b.descrizione) ? 1 : -1);
                        }
                    });
                    console.log(this.resources);
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        loadVehicles() {
            console.log("loading workers...");
            EasyPlanClient.Resources.GetAllVehicles(this.$route.params.companyAlias)
                .then((res) => {
                    this.resources = res.data.data.sort((a, b) => {
                        if (a.prioritaOrdinamento > b.prioritaOrdinamento) {
                            return 1;
                        }
                        else if (a.prioritaOrdinamento < b.prioritaOrdinamento) {
                            return -1;
                        }
                        else {

                            return ((a.descrizione > b.descrizione) ? 1 : -1);
                        }
                    });
                    console.log(this.resources);
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        loadEquipments() {
            console.log("loading workers...");
            EasyPlanClient.Resources.GetAllEquipments(this.$route.params.companyAlias)
                .then((res) => {
                    this.resources = res.data.data.sort((a, b) => {
                        if (a.prioritaOrdinamento > b.prioritaOrdinamento) {
                            return 1;
                        }
                        else if (a.prioritaOrdinamento < b.prioritaOrdinamento) {
                            return -1;
                        }
                        else {

                            return ((a.descrizione > b.descrizione) ? 1 : -1);
                        }
                    });
                    console.log(this.resources);
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        loadUsers() {
            console.log("loading users...");
            EasyPlanClient.User.GetAll(this.$route.params.companyAlias)
                .then((res) => {
                    this.users = res.data.data.sort((a, b) => (a.username > b.username) ? 1 : -1);
                })
                .catch((error) => {
                    console.log(error);
                    this.error = EasyPlanClient.GetErrorDescription(
                        error.response.data.errorCode
                    );
                    console.error(
                        "si è verificato un errore (" +
                        error.response.data.errorCode +
                        ")" +
                        this.error
                    );
                    console.error(error);
                });
        },
        loadEvents() {
            this.isLoading = true;
            console.log("loading workers...", this.$refs);
            if (this.$refs.calendar != undefined)
                EasyPlanClient.Event.FindByCompanyAliasDateFromTo(
                    this.$route.params.companyAlias,
                    this.$refs.calendar.GetPeriodStart(),
                    this.$refs.calendar.GetPeriodEnd()
                )
                    .then((res) => {
                        let loadedEvents = res.data.data;

                        //PER REFRESH PERIODICO
                        let newEvents = loadedEvents.filter(e => this.events.find(ev => ev.idIntervento == e.idIntervento && ev.inizio == e.inizio) == undefined);
                        let editedEvents = loadedEvents.filter(e => {
                            let old = this.events.find(ev => ev.idIntervento == e.idIntervento && ev.inizio == e.inizio) != undefined
                            return (JSON.stringify(old) !== JSON.stringify(e));
                        });
                        let removedEvents = this.events.filter(e => res.data.data.find(ev => ev.idIntervento == e.idIntervento && ev.inizio == e.inizio) == undefined);
                        if (newEvents.length > 0 || removedEvents.length > 0 || editedEvents.length > 0) {

                            this.events = loadedEvents;
                            console.log("eventi", this.events);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.error = EasyPlanClient.GetErrorDescription(
                            error.response.data.errorCode
                        );
                        console.error(
                            "si è verificato un errore (" +
                            error.response.data.errorCode +
                            ")" +
                            this.error
                        );
                        console.error(error);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
        },

        canEditOtherUserEvents() {
            let currUser = JSON.parse(localStorage.currentUser);
            let p = currUser.ruolo.permessi.find(
                (p) => p.idPermesso == "MANAGE_OTHER_USER_EVENTS"
            );
            if (p != undefined) {
                return p.abilitato;
            }
            return false;
        },
        loadResources(type) {
            switch (type) {
                case "Uomo":
                    this.loadWorkers();
                    break;
                case "Mezzo":
                    this.loadVehicles();
                    break;
                case "Attrezzatura":
                    this.loadEquipments();
                    break;
                case "All": //è come Uomo ma il form di edit è quello completo di tutto
                    this.loadWorkers();
            }
        },
    },
    async created() {
        UISettingsHelper.Configure(this.$route.params.companyAlias);
        this.fullscreen = this.fullScreen;
        this.showOptionsD = this.showOptions;
        this.loadResources(this.resourceType);
        this.loadActions(this.resourceType);
        this.loadEvents();
        setInterval(this.loadEvents, this.$props.refreshInterval);
        this.loadUsers();
        window.addEventListener("resize", () => {
            this.resizing = !this.resizing;
        });
        this.hideButtons(["Annulla", "Conferma"]);
    },

    computed: {

        UISettings() {
            UISettingsHelper.LoadSettings();
            return UISettingsHelper.GetSettings();
        },
        maxTableHeight() {
            let h = 0;
            if (this.fullscreen && this.$refs.cardTitle != undefined) {
                let res = this.resizing;
                res = !res;
                h = window.innerHeight - this.$refs.cardTitle.clientHeight - 33;
            } else h = this.height;
            h -= this.showOptionsD ? 160 : 0;
            return h + "px";
        },
        cardStyle() {
            if (this.fullscreen)
                return {
                    position: "fixed",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    "z-index": "3000",
                };
            else return {};
        },
        canChangeEventOwner() {
            let currUser = JSON.parse(localStorage.currentUser);
            let p = currUser.ruolo.permessi.find(
                (p) => p.idPermesso == "CHANGE_EVENTS_OWNER"
            );
            if (p != undefined) {
                return p.abilitato;
            }
            return false;
        },
        // isEventCreatorP() {
        //   console.debug("isEventCreatorP, selectedCellData", this.selectedCellData);
        //   let isCreator = false;
        //   if (this.selectedCellData != null)
        //     isCreator = this.isEventCreator(
        //       this.selectedCellData.day,
        //       this.selectedCellData.item
        //     );
        //   console.debug("isEventCreator", isCreator);
        //   return isCreator;
        // },
        ShowSnackbar: {
            get() {
                return this.error.length > 0;
            },
            set(value) {
                if (!value) this.error = "";
            },
        },
    },
}